import { useEffect, useState } from 'react';
import { isCanceledRequest } from '../../Components/Students/examData';

// Hisobotni yuklaydi: { status: 'idle' | 'loading' | 'success' | 'error', data }.
// Shu obyekt qayta yuklanayotganda (davr o'zgardi, "Yangilash") eski data ekranda qoladi,
// boshqa obyektga o'tilganda tozalanadi. Kech kelgan javob yangisining ustiga yozilmaydi.
export function useReport(fetcher, id, days, reload) {
  const [state, setState] = useState({ status: 'idle', data: null, id: null });

  useEffect(() => {
    if (!id) {
      setState({ status: 'idle', data: null, id: null });
      return undefined;
    }
    const controller = new AbortController();
    setState((prev) => ({ status: 'loading', data: prev.id === id ? prev.data : null, id }));
    fetcher(id, days, controller.signal)
      .then((data) => {
        if (!controller.signal.aborted) setState({ status: 'success', data, id });
      })
      .catch((err) => {
        if (isCanceledRequest(err) || controller.signal.aborted) return;
        console.log(err);
        setState((prev) => ({ ...prev, status: 'error' }));
      });
    return () => controller.abort();
  }, [fetcher, id, days, reload]);

  return state;
}

export const DAY_OPTIONS = [
  { value: 7, label: '7 kun' },
  { value: 30, label: '30 kun' },
  { value: 90, label: '90 kun' },
];
